import { Component, NgZone, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { api } from 'src/app/@shared/services/api';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';
import { script } from 'src/app/@shared/javascript/script';
import { CommonService } from 'src/app/@shared/services/common.service';
import { LoginPageComponent } from '../login-page/login-page.component';
declare var $: any;


@Component({
  selector: 'app-home-white-label-wise',
  templateUrl: './home-white-label-wise.component.html',
  styleUrls: ['./home-white-label-wise.component.css']
})
export class HomeWhiteLabelWiseComponent implements OnInit {

  public api = api;
  public env = environment;
  public menu: any[] = [];
  modalRef!: BsModalRef;

  
  constructor(private modalService: BsModalService,
    private router: Router,
    public service: WebserviceService,
    public _common: CommonService,
    private _message: MessageService) { }
  // constructor(private router: Router) { }

  ngOnInit(): void {
    $('.owl-carousel').owlCarousel({
      center: true,
      loop: true,
      margin: 30,
      autoplay: true,
      responsiveClass: true,
      responsive:{
          0:{
              items: 2,
          },
          767:{
              items: 3,
          },
          1200:{
              items: 4,
          }
      }
  });
    if (localStorage.getItem(`${this.env.panel}id_token`)) {
      this.router.navigate(["/dashboard"]);
    }

    this.menu = (localStorage.getItem(`${this.env.panel}menu`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}menu`) as any) : [];
    if (this.menu.length == 0) { this.getMenu(); }
    // script();
  }

  getServices(): IbaseService<any> {
    return this.service;
  }


  getMenu() {
    this.getServices().Get(`${this.env.baseUrl + this.api.menu}`).subscribe(
      (res) => {
        if (res.status == true) {
          if (!localStorage.getItem(`${this.env.panel}stakes`)) {
            localStorage.removeItem(`${this.env.panel}stakes`);
            localStorage.setItem(`${this.env.panel}stakes`, JSON.stringify(this.env.stakes));
          }
          localStorage.removeItem(`${this.env.panel}menu`);
          localStorage.setItem(`${this.env.panel}menu`, JSON.stringify(res?.data?.menu));
          this.menu = res?.data?.menu;
        }
      },
      (err) => {
        console.log(err);
      });
  }

  openModal(template: TemplateRef<any>) {
    // this.modalRef = this.modalService.show(template, { class: 'log-reg-ui modal-md' });
    this.modalRef = this.modalService.show(template, { class: 'login-popup-ui' });
  }

  openSignUpModal() {
    this._common.openModalWithComponent({ signUpModal: true }, LoginPageComponent, 'signup_modal')
  }

  closeModel() {
    this.modalRef.hide();
  }

  openAppMoadal(template: TemplateRef<any>) {
    this.modalRef.hide();
    this.openModal(template);
  }

  loginRoute() {
    this.router.navigate(['/login'])
  }

  mobNavShow() {
    // document.body.classList.add('mobile-nav-active')
  }
  mobNavHide() {
    // document.body.classList.remove('mobile-nav-active')
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }
}
